import BaseRequest from './BaseRequest';
import { API_URL } from '../config/config';

const AutoridadeAPI = {
  async buscarDetalhesAutoridade(codAutoridade, cancelToken = null) {
    // const BaseRequest = await loadBaseAPI();
    const options = { headers: BaseRequest.publicHeaders, cancelToken };
    return BaseRequest.axiosInst.get(`${API_URL}/autoridade/${codAutoridade}`, options);
  },

  async getImages(cod_autoridade, limit = 0, cancelToken = null) {
    // const BaseRequest = await loadBaseAPI();
    const options = {
      headers: BaseRequest.publicHeaders,
      params: { cod_autoridade, limit },
      cancelToken,
    };
    return BaseRequest.axiosInst.get(`${API_URL}/autoridade/get-images`, options);
  },
};

export default AutoridadeAPI;
